import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AutoDecryptField } from './use-auto-decrypt-controls';

export type AutoDecryptStoreState = {
  enabled: boolean;
  reason: string;
  fields: AutoDecryptField[];
  fpIdsBeingDecrypted: Record<string, boolean>; // Not using a Set because Zustand persist serializes Sets to arrays
  expiresAt: number | null;
};

export const initialState: AutoDecryptStoreState = {
  enabled: false,
  reason: '',
  fields: [],
  fpIdsBeingDecrypted: {},
  expiresAt: null,
};

export const usePersonAutoDecryptStore = create<AutoDecryptStoreState>()(
  persist(set => ({ ...initialState, reset: () => set(initialState) }), {
    name: 'user-auto-decrypt-store',
    version: 1,
  }),
);

export const useBusinessAutoDecryptStore = create<AutoDecryptStoreState>()(
  persist(set => ({ ...initialState, reset: () => set(initialState) }), {
    name: 'business-auto-decrypt-store',
    version: 1,
  }),
);

// This selector will cause re-renders when the enabled state changes
export const enabledSelector = (state: AutoDecryptStoreState) => state.enabled;

export const resetAutoDecryptStores = () => {
  usePersonAutoDecryptStore.setState(initialState);
  useBusinessAutoDecryptStore.setState(initialState);
};
